/**
 * Touch swipe detection for mobile track navigation.
 * Returns a cleanup function to remove listeners.
 */
export function onSwipe(
  el: HTMLElement,
  callbacks: { onLeft?: () => void; onRight?: () => void },
  options: { threshold?: number; maxVertical?: number } = {},
): () => void {
  const threshold = options.threshold ?? 60;
  const maxVertical = options.maxVertical ?? 100;
  let startX = 0;
  let startY = 0;

  function onTouchStart(e: TouchEvent) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }

  function onTouchEnd(e: TouchEvent) {
    const dx = e.changedTouches[0].clientX - startX;
    const dy = Math.abs(e.changedTouches[0].clientY - startY);

    // Ignore if vertical movement dominates (scrolling)
    if (dy > maxVertical) return;
    if (Math.abs(dx) < threshold) return;

    if (dx < 0) callbacks.onLeft?.();
    else callbacks.onRight?.();
  }

  el.addEventListener('touchstart', onTouchStart, { passive: true });
  el.addEventListener('touchend', onTouchEnd, { passive: true });

  return () => {
    el.removeEventListener('touchstart', onTouchStart);
    el.removeEventListener('touchend', onTouchEnd);
  };
}
